import { render, staticRenderFns } from "./examine-details.vue?vue&type=template&id=e3159e04&scoped=true&"
import script from "./examine-details.vue?vue&type=script&lang=js&"
export * from "./examine-details.vue?vue&type=script&lang=js&"
import style0 from "./examine-details.vue?vue&type=style&index=0&id=e3159e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3159e04",
  null
  
)

export default component.exports